import React, { useEffect, useState } from "react";
import { Button, Modal, Input, message, Spin } from "antd";
import { useSelector, connect } from "react-redux";
import { getMerchantByDispatch } from "../../../redux/actions/orders";
import { useDispatch } from "react-redux";
import { usePaystackPayment } from "react-paystack";
import ConfirmModal from "./ConfirmModal";
import { ADD_ORDERS } from "../../../constants";
import { useMutation } from "@apollo/client";
import { getApp } from "../../../redux/actions/merchant";
import { useParams, useLocation } from "react-router-dom";
import { saveInvoice } from "../../../redux/actions/ussdActions";
import axios from "axios";
import CredpalProcessModal from "./credpal";
import BankTransferModal from "./BankTransferModal";
import { LoadingOutlined } from '@ant-design/icons';
import { sendDelivery } from "../../../redux/actions/delivery";

const AskPayment = ({
  open,
  onCancel,
  merchant,
  onClickTill,
  onClickUSSD,
  onClickGiftCard,
  onClickReserve,
  onClickBankTransfer,
  setDeliveryDetails,
  paywithDelivery,
  handlePayStackPayment,
  setShowInStoreOrders,
  handleStripePayment,
  getInStoreLoading,
  isPayStack,
  isStripeEnabled,
  isCredPalEnabled,
  setOrderDetails,
  deliveryPrice,
  loading,
  sendDeliveryRequest,
  handlePostSales,
  serviceAmount,
  deliveryMethod,
  orderTotal
}) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { giftcard } = useSelector((state) => state.urewardsAuth);
  const { carts } = useSelector((state) => state.Order);
  // const {
  //   success: merchantsuccess,
  //   loading: merchantloading,
  //   merchanted,
  // } = useSelector((state) => state.merchantState);
  const { merchantDetails } = useSelector((state) => state.merchant);
  const [showDelivery, setShowDelivery] = useState(false);
  const [email, setEmail] = useState("");
  const [deliveryAddress, setDeliveryAddress] = useState("");
  const [isUSSD, setIsUSSD] = useState(false);
  const [isInStore, setIsInStore] = useState(false);
  const [isGiftCard, setIsGiftCard] = useState(false);
  const [address_line1, setAddress_line1] = useState("");
  const [address_line2, setAddress_line2] = useState("");
  const [state, setState] = useState("");
  const [country, setCountry] = useState("");
  const [postal_code, setPostal_code] = useState("");
  const [showPayStack, setShowPayStack] = useState(false);
  const [PayStackLoading, setPayStackLoading] = useState(false);
  const [gettingPayStack, setgettingPayStack] = useState(false);
  const [ isStripeLoading, setIsstripeLoading ] = useState(false);
  const [ searchParams, setSearchParams ] = useState(null);
  const [ stripePaymentStatus, setStripePaymentStatus ] = useState(false);
  const [ openCredpalModal, setOpenCredpalModal ] = useState(false);
  const [ showBankTransferModal, setShowBankTransferModal ] = useState(false);
  const [ bankTransferLoading, setBankTransferLoading ] = useState(false);
  const [payStackKey, setPayStackKey] = useState(null);
  const storageUser = localStorage.getItem("user_customer_details");
  const user = storageUser ? JSON.parse(storageUser) : null;
  const { orderdetails } = useSelector((state) => state.Orders);
  const [addOrders] = useMutation(ADD_ORDERS);
  
  useEffect(()=>{
    const { search} = location;
    if(search !== ""){
      const searchQuery = search.split("=")[1];
      setSearchParams(searchQuery);
    }
  }, [location]);

  const getMerchantPayStackDetails = async () => {
    const merchant = localStorage.getItem("urewards_merchant_details");
    if (merchant) {
      setgettingPayStack(true);
      const merch = JSON.parse(merchant);
      const merchant_email = merch.email;
      await axios
        .post(
          `${process.env.REACT_APP_MULTI_LEVEL_BASE_URL}/urewards_merchant_paystack_details`,
          { merchant_email },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          if (response.status === 200) {
            setgettingPayStack(false);
            setPayStackKey(response.data.data.data);
          } else {
            setgettingPayStack(false);
            setPayStackKey(null);
          }
        })
        .catch((err) => {
          setgettingPayStack(false);
          setPayStackKey(null);
          message.error(`${err.response.statusText}`);
        });
    }
  };

  useEffect(() => {
    isPayStack && getMerchantPayStackDetails();
  }, []);


  const totalOrder = (cart) => {
    if (cart && cart.length === 0 ) return 0;
    const cartItemWithVariants = cart.filter((item)=>{
      return item.variants && item.variants.length > 0;
    });

    const cartItemsWithCust = cart.filter((item)=>{
      return item.custom_quantities && item.custom_quantities.length > 0;
    });

    const cartBundle = cart.filter((item)=>{
      return item.bundle_quantity && typeof item.bundle_quantity === "object";
    });

    const normItem = cart.filter((item)=>{
      return item.variants && item.variants.length === 0 && item.custom_quantities && item.custom_quantities.length === 0;
    });
    
    const totalVaraiant = cartItemWithVariants.reduce((prev, curr)=>{
      return Number(prev) + (Number(curr.quantity) * Number(curr.variants[0].price));
    }, 0);

    const totalCust = cartItemsWithCust.reduce((prev, curr)=>{
      return Number(prev) + (Number(curr.quantity) * Number(curr.custom_quantities[0].price));
    }, 0);

    const totalBundle = cartBundle.reduce((prev, curr)=>{
      return Number(prev) + (Number(curr.quantity) * Number(curr.price));
    }, 0);

    const otherTotal = normItem.reduce((prev, curr) => {
      return prev + Number(curr.quantity) * Number(curr.price);
    }, 0); 

    return otherTotal + totalCust + totalVaraiant + totalBundle;
  };

  const totalStackOrder = (cart) => {
    if (cart.length === 0) return 0;
    const cartItemWithVariants = cart.filter((item) => {
      return item.variants && item.variants.length > 0;
    });

    if (cartItemWithVariants.length === 0) {
      return (cart.reduce((prev, curr) => {
        return Math.round(prev + curr.quantity * curr.price);
      }, 0) * 100)
    } else {
      const cartItemNotWithVariants = cart.filter((item) => {
        return item.variants === undefined || item.variants.length === 0;
      });

      const itemNotVariantsTotal = cartItemNotWithVariants.reduce(
        (prev, curr) => {
          return Number(prev) + Number(curr.quantity) * Number(curr.price);
        },
        0
      );

      const itemVariantsTotal = cartItemWithVariants.reduce((prev, curr) => {
        return (
          Number(prev) + Number(curr.quantity) * Number(curr.variants[0].price)
        );
      }, 0);
      return (itemNotVariantsTotal + itemVariantsTotal) * 100;
    }
  };

  const paystackConfig = {
    reference: new Date().getTime().toString(),
    email: merchant.email,
    currency: merchant.currency,
    amount: deliveryPrice ? totalStackOrder(carts)+(Number(deliveryPrice) * 100) : carts && totalStackOrder(carts),
    publicKey: process.env.REACT_APP_PAYSTACK_PUBLIC_KEY,
  };

  useEffect(() => {
    setEmail(email);
  }, [email]);

  useEffect(() => {
    setDeliveryAddress(deliveryAddress);
  }, [deliveryAddress]);

  useEffect(() => {
    dispatch(getMerchantByDispatch());
  }, []);

  const handleSetDelivery = () => {
    if (
      email === "" ||
      address_line1 === "" ||
      address_line2 == "" ||
      state === "" ||
      country === ""
    ) {
      return message.info("Please fill all fields");
    }

    if (isGiftCard) {
      onClickGiftCard();
    } else if (isInStore) {
      onClickTill();
    }
    setShowDelivery(false);
  };

  const handleBankTransfer = () => {
    setShowBankTransferModal(true);
  };

  const handleBankTransferConfirm = (receiptData) => {
    console.log('askPayment: handleBankTransferConfirm called with:', receiptData);
    setBankTransferLoading(true);
    
    // Call the parent component's bank transfer handler with receipt data
    if (onClickBankTransfer) {
      onClickBankTransfer(receiptData);
    }
    
    setShowBankTransferModal(false);
    setBankTransferLoading(false);
    onCancel();
  };

  const handlePayStack = usePaystackPayment(paystackConfig);

  const paymentCallback = (resp) => {
    if (resp.message === "Approved") {
      setShowInStoreOrders(true);
      setPayStackLoading(false);
      setShowPayStack(false);
      onCancel();
      addOrders({
        variables: { data: orderdetails },
        onCompleted: (respo) => {
          setPayStackLoading(false);
          setShowPayStack(false);
          onCancel();
          handlePostSales(orderdetails, "card");
        },
        onError: (err) => {
          setPayStackLoading(false);
          Modal.error({
            title: `${err.message}, pls try again`,
          });
        },
      });
      paywithDelivery && merchantDetails.currency === "NGN" && sendDeliveryRequest();
    } else {
      Modal.error({
        title: `payment not successful, please try again!`,
      });
    }
  };

  const baseUrl = process.env.REACT_APP_BASE_URL;

  const convertCartsToParams = (carts) => {
    
    const lineItems = carts.map((cartItem)=>{
      const { price, quantity, variants, custom_quantities } = cartItem;

      const priceData = {
        price_data: {
          currency: merchant.currency,
          product_data: {
            ...cartItem,
            price: variants && variants.length > 0 ? Number(variants[0].price) : custom_quantities && custom_quantities.length > 0 ? Number(custom_quantities[0].price) : Number(price)
          },
          unit_amount: variants && variants.length > 0 ? Number(variants[0].price) * 100 :  custom_quantities && custom_quantities.length > 0 ? Number(custom_quantities[0].price) * 100 : Number(price) * 100,
        },
        quantity: quantity,
      }
      return priceData;
    });
    const deliveryItem = {
      price_data: {
        currency: merchant.currency,
        product_data: {
          // ...cartItem,
          amount: 1,
          name: "delivery fee",
          price: deliveryPrice ? Number(deliveryPrice) * 100 : 0,
        },
        unit_amount: deliveryPrice ? Number(deliveryPrice) * 100 : 0,
      },
      quantity: 1,
    }

    const params = {
      amount_total: totalOrder(carts) * 100 + (Number(deliveryPrice) * 100) || 0,
      total_amount: totalOrder(carts) * 100 +  (Number(deliveryPrice) * 100) || 0,
      merchant_id: merchantDetails.id,
      line_items: deliveryPrice ? [...lineItems, deliveryItem] : lineItems,
      success_url: `/cart?payment=successful `,
      cancel_url: `/cart?payment=cancelled`,
    };
    return params;
  };
  const params = convertCartsToParams(carts);

  const sendParamsToBackend = (params) => {
    setIsstripeLoading(true);
    const subUrl = "/merchant/stripe_checkout_session";
    const URL = `${baseUrl}/api/v2${subUrl}`;

    axios
    .post(URL, {
      data: params,
    })
    .then((response) => {
      localStorage.setItem("delivery_price", JSON.stringify(deliveryPrice))
      window.open(response.data.url, "_self");
      setIsstripeLoading(false);
    })
    .catch((error) => {
      console.error("Error sending data to backend:", error);
      message.error("An error occurred while processing your request.");
      setIsstripeLoading(false);
    });
  };

  // useEffect(() => {
  //   const { search} = location;
  //   if(search !== ""){
  //     const searchQuery = search.split("=")[1];
  //     if (searchQuery === "successful") {
  //       message.success("Payment confirmed")
  //       setStripePaymentStatus(true);
  //       handleStripePayment();
  //     } else if (searchQuery === "cancelled") {
  //       message.error("Unable to process your stripe payment, please try again")
  //       setStripePaymentStatus(false);
  //     }
  //   }
  // }, [location]);
  const total = deliveryPrice ? totalOrder(carts)+Number(deliveryPrice) : totalOrder(carts);
  const totalStack = deliveryPrice ? totalStackOrder(carts)+Number(deliveryPrice) : totalStackOrder(carts);

  return (
    <>
      <Modal
        open={open}
        // open={true}
        onCancel={onCancel}
        className="checkout_modal1"
        // onOk={()=>handleCancelOrder()}
        footer={null}
      >
        <div
          style={{
            textAlign: "center",
            display: "flex",
            flexDirection: "column",
            marginTop: "2rem",
          }}
        >
          <span
            style={{
              fontSize: "20px",
              fontWeight: "600",
              padding: "0 1rem",
              lineHeight: "24px",
            }}
          >
            How would you like to pay
          </span>
          <div style={{ height: "15px" }}></div>
          <span
            style={{
              fontSize: "14px",
              fontWeight: "600",
              opacity: "0.6",
            }}
          >
            {`Total due${deliveryPrice ? " (+delivery)" : ""}:`}
          </span>
          {loading ? <div style={{display: "flex", alignItems: "center", justifyContent: "center"}}><Spin size="small" indicator={<LoadingOutlined style={{fontSize: 20}} spin />} /></div>:<span
            style={{
              fontSize: "32px",
              fontWeight: "600",
              lineHeight: "38.73px",
            }}
          >
            {merchantDetails &&
              merchantDetails?.currency + total.toFixed(2)}
             {/* {deliveryPrice ? <span style={{fontSize:12}}>(+delivery fee)</span> : null}  */}
          </span>}
        </div>
        <div style={{ height: "10px" }}></div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: "0.5rem",
          }}
        >
          {/*paywithDelivery === false &&   */}
          {/* {(!deliveryPrice && <Button
              className="cart_buttons"
              onClick={() => onClickTill()}
              type="primary"
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <span>Pay at Collection</span>
              </div>
            </Button>
          )} */}

          {isStripeEnabled && merchant.currency === "GBP" && (
            <Button
              className="cart_buttons"
              onClick={() => !stripePaymentStatus && sendParamsToBackend(params)}
              type="primary"
              loading={isStripeLoading || getInStoreLoading}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <span>{paywithDelivery ? "Pay Now" : "Pay 'n' Pickup"}</span>
              </div> 
            </Button>
          )}
          {isPayStack && merchant?.currency === "NGN" && (
            <Button
              className="cart_buttons"
              onClick={() => {
                setPayStackLoading(true);
                handlePayStackPayment(carts, user, totalStack);
                handlePayStack(paymentCallback, () => setPayStackLoading(false));
              }}
              loading={gettingPayStack}
              type="primary"
            >
              <div
                style={{
                  display: "flex",
                  gap:0,
                  alignItems: "center",
                  flexDirection: "column",
                }}
              >
                <span>Make Payment</span>    
              </div>
            </Button>
          )}
          {giftcard !== null && (
            <Button className="cart_buttons" onClick={() => onClickGiftCard()}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <span>Spend GiftCard</span>
              </div>
            </Button>
          )}
          {/* Bank Transfer button - available for both Pickup and Delivery */}
          <Button 
            className="cart_buttons" 
            onClick={handleBankTransfer}
            type="primary"
            loading={bankTransferLoading}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
              }}
            >
              <span>Bank Transfer</span>
              <span style={{fontSize: "12px", opacity: 0.8}}>Upload receipt</span>
            </div>
          </Button>
          {/* Reserve Order button - available for both Pickup and Delivery */}
          {!paywithDelivery && giftcard === null && (
            <Button 
              className="cart_buttons" 
              onClick={() => onClickReserve()}
              type="primary"
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <span>Reserve Order</span>
                <span style={{fontSize: "12px", opacity: 0.8}}>72 hours hold</span>
              </div>
            </Button>
          )}
          <p className="cart_action" onClick={onCancel}>
            Cancel
          </p>
        </div>
      </Modal>
      <ConfirmModal
        open={showPayStack}
        onCancel={() => setShowPayStack(false)}
        onOk={() => {
          setPayStackLoading(true);
          handlePayStack(paymentCallback, () => {});
        }}
        body="Proceed to pay with Paystack"
        loading={PayStackLoading}
      />

      <Modal
        open={showDelivery}
        onCancel={() => setShowDelivery(false)}
        title="Update Address"
        onOk={() => handleSetDelivery()}
        destroyOnClose
      >
        <Input
          placeholder="Email address"
          value={email}
          name="email"
          onChange={(e) => {
            const { name, value } = e.target;
            setEmail(value);
            setDeliveryDetails((prev) => {
              return {
                ...prev,
                [name]: value,
              };
            });
          }}
          type="email"
        />
        {/* <div style={{height: "10px"}}></div>
    <Input 
        placeholder="Delivery address"
        value={deliveryAddress}
        name="deliveryAddress"
        onChange={(e)=>{
            const { name, value } = e.target;
            setDeliveryAddress(value);
            setDeliveryDetails((prev)=>{
                return {
                    ...prev,
                    [name]: value
                }
            })
        }}
        type="text"
    /> */}
        <div style={{ height: "10px" }}></div>
        <Input
          placeholder="address_line1"
          value={address_line1}
          name="address_line1"
          onChange={(e) => setAddress_line1(e.target.value)}
          type="text"
        />
        <div style={{ height: "10px" }}></div>
        <Input
          placeholder="address_line2"
          value={address_line2}
          name="address_line2"
          onChange={(e) => setAddress_line2(e.target.value)}
          type="text"
        />
        <div style={{ height: "10px" }}></div>
        <Input
          placeholder="state"
          value={state}
          name="state"
          onChange={(e) => setState(e.target.value)}
          type="text"
        />
        <div style={{ height: "10px" }}></div>
        <Input
          placeholder="country"
          value={country}
          name="country"
          onChange={(e) => setCountry(e.target.value)}
          type="text"
        />
        <div style={{ height: "10px" }}></div>
        <Input
          placeholder="postal_code"
          value={postal_code}
          name="postal_code"
          onChange={(e) => setPostal_code(e.target.value)}
          type="text"
        />
      </Modal>
      <BankTransferModal
        open={showBankTransferModal}
        onCancel={() => setShowBankTransferModal(false)}
        onConfirm={handleBankTransferConfirm}
        loading={bankTransferLoading}
        merchantDetails={merchantDetails}
        total={orderTotal}
        currency={merchantDetails?.currency || merchant?.currency}
      />
    </>
  );
};

const mapStateToProps = (state) => ({
  state: state,
  carts: state.carts,
  merchantDetails: state.merchantDetails,
  orderdetails: state.orderdetails,
  urewardsAuth: state.urewardsAuth,
  merchantState: state.merchantState,
});
export default connect(mapStateToProps)(AskPayment);
